export const SET_GESCHAEFTSJAHRE = "setGeschaeftsjahre";
export const SET_GESCHAEFTSJAHR = "setGeschaeftsjahr";
